import { logToDataLayer } from './LogHelper';

export const priceMatrixSearch = (loggingData, translatedMessage) => {
  let error = '';
  if (translatedMessage && translatedMessage.severity !== 'information') {
    error = `${translatedMessage?.errorCode}:${translatedMessage?.program}:${translatedMessage?.systemId}`;
  }

  if (loggingData) {
    logToDataLayer({
      event: loggingData.event,
      hotelWVId: loggingData.hotelWvId, // No travel prefix (by request)
      travelAction: loggingData.action,
      travelAdults: loggingData.numberOfAdults,
      travelAges: loggingData.passengerAges,
      travelAlternativeHotelsCount: loggingData.alternativeHotelsCount,
      travelAlternativeResult: loggingData.alternativeResult,
      travelChildren: loggingData.numberOfChildren,
      travelCountryCode: loggingData.countryCode || undefined,
      travelDepartureCode: loggingData.departureCode,
      travelDepartureDay: loggingData.departureDateDay,
      travelDepartureMonth: loggingData.departureDateMonth,
      travelDepartureYear: loggingData.departureDateYear,
      travelDestinationCode: loggingData.destinationCode,
      travelDuration: loggingData.duration,
      travelHits: loggingData.numberOfHits,
      travelHotelCode: loggingData.hotelCode || undefined,
      travelHotelProvider: loggingData.travelHotelProvider || undefined,
      travelPax: loggingData.numberOfPassengers,
      travelPrice: loggingData.travelPrice,
      travelResortCode: loggingData.resortCode,
      travelType: loggingData.travelType,
      ...(error && { error }),
    });
  }

  if (error) {
    logToDataLayer({
      error,
      event: 'CA error',
    });
  }
};
